export default {"src":"/_next/static/media/pill_24.9efec0ed.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};